// extracted by mini-css-extract-plugin
module.exports = {"CategoriesSection":"CategoriesSection_CategoriesSection__q3DL7","categories":"CategoriesSection_categories__2Yjgt","category":"CategoriesSection_category__kiRYG"};